var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { injectable } from 'inversify';
let UnitProcessor = class UnitProcessor {
    constructor() {
        this.processUnitsTree = this.processUnitsTree.bind(this);
    }
    /**
     * Преобразует дерево UnitNode к объекту
     *
     * @param node - Узел дерева подразделений
     * @returns Узел с полями для отображения
     */
    processUnitsTree(node) {
        return {
            id: node.id,
            label: node.name,
            count: node.employee_count || 0,
            hasChildrenToLoad: node.is_parent,
            hasSeparateAbove: node.has_separate_above,
            isSeparate: node.is_separate,
            children: node.children ? node.children.map(this.processUnitsTree) : [],
        };
    }
};
UnitProcessor = __decorate([
    injectable(),
    __metadata("design:paramtypes", [])
], UnitProcessor);
export { UnitProcessor };
